import React from "react";
import styled from "styled-components";
import TestimonialCard from "./sub-components/TestimonialsCard";
import { SectionHeadline } from "./Typography";

const Section = styled.section`
    margin-top: 4rem;
    padding: 10px;
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    border-radius: 8px;
`;

const Heading = styled(SectionHeadline)`
    text-align: left;
    display: block;
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 12px 0;
  width: 100%;

  /* A lone testimonial would otherwise stretch the full page width and run to a
     110-character line. Hold it to a readable measure instead. */
  &:has(> :only-child) {
    max-width: 78ch;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;


const TestimonialSection = ({ title, testimonials }) => {
    if (!testimonials || testimonials.length === 0) return null;

    return (
        <Section>
            <Heading>{title}</Heading>
            <TestimonialsGrid>
                {testimonials.map((testimonial, i) => (
                    <TestimonialCard
                        key={i}
                        name={testimonial.name}
                        title={testimonial.title}
                        body={testimonial.body}
                    />
                ))}
            </TestimonialsGrid>
        </Section>
    );
};

export default TestimonialSection;
